<template>
  <v-container
    fluid

    grid-list-xl
  >
    <v-row justify="center">

      <v-col>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col><a @click="backToProject"> {{$t("potentialIncidents.show.backToProject")}}</a></v-col>
            </v-row>
            <h2 class="font-weight-light mb-4">
              {{$t("potentialIncidents.show.header")}}
            </h2>

            <v-row>
              <v-col>
                <v-btn
                  :to="{ name: 'PotentialIncidentEdit', params: { 'id': id }}"
                  v-if="userHasAuthority('MANAGE_PROJECTS')">
                  {{$t("potentialIncidents.show.edit")}}
                </v-btn>
                &nbsp;<v-btn
                @click="clonePotentialIncident"
                v-if="userHasAuthority('MANAGE_PROJECTS')">{{$t('potentialIncidents.show.clone')}}
              </v-btn>
              </v-col>
            </v-row>


            <v-container class="pa-0" fluid>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.logicalId')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{logicalId}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.workOperation')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{workOperationName}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.workType')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{workTypeName}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.location')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{location}}
                  </div>
                </v-col>
              </v-row>

              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.incidentType')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{incidentTypeName}}
                  </div>
                </v-col>
              </v-row>

              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.explanation')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div style="white-space: pre-line;">
                    {{explanation}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.consequenceType')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{consequenceTypeName}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.consequence')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{consequenceText}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.probability')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{probability.name}} ({{probability.id}})
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.risk')}}:
                  </div>
                </v-col>
                <v-col cols="2">
                  <div :class="riskColor">
                    {{risk}}
                  </div>
                </v-col>
              </v-row>


              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.consequenceAfterMeasures')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{consequenceAfterMeasuresText}}
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.probabilityAfterMeasures')}}:
                  </div>
                </v-col>
                <v-col cols="8">
                  <div class="h2">
                    {{probabilityAfterMeasuresText}}

                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="2">
                  <div class="h2 font-weight-bold">
                    {{$t('potentialIncident.riskAfterMeasures')}}:
                  </div>
                </v-col>
                <v-col cols="2">
                  <div :class="riskAfterMeasuresColor">
                    {{riskAfterMeasures}}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
<v-expansion-panels multiple popout>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <h2 class="font-weight-light mb-4">
        {{$t('potentialIncident.barriers')}}
      </h2>
    </v-expansion-panel-header>
    <v-expansion-panel-content>

      <v-row v-for="barrier in barriers">
        <v-col>


          <v-card elevation="2">
            <v-card-text>
              <v-container class="pa-0" fluid>

                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">
                      {{$t('barrier.description')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2">
                      {{barrier.description}}
                    </div>
                  </v-col>
                </v-row>

                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">

                      {{$t('barrier.type')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2" v-if="barrier.type!=''">
                      {{$t('barrierType.' +barrier.type)}}
                    </div>
                  </v-col>
                </v-row>

                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">
                      {{$t('barrier.strong')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2" v-if="barrier.strength">
                      {{$t('global.yes')}}
                    </div>
                    <div class="h2" v-else>
                      {{$t('global.no')}}
                    </div>
                  </v-col>
                </v-row>


                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">
                      {{$t('barrier.owner')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2">
                      {{barrier.owner.name}}
                    </div>
                  </v-col>
                </v-row>
                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">
                      {{$t('barrier.comment')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div style="white-space: pre-line;">
                      {{barrier.comment}}
                    </div>
                  </v-col>
                </v-row>


              </v-container>

            </v-card-text>
          </v-card>

        </v-col>
      </v-row>


    </v-expansion-panel-content>

  </v-expansion-panel>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <h2 class="font-weight-light mb-4">
        {{$t('potentialIncident.measures')}}
      </h2>


    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row v-for="measure in measures">
        <v-col>


          <v-card elevation="2">
            <v-card-text>
              <v-container class="pa-0" fluid>

                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">
                      {{$t('measure.measure')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2">
                      {{measure.measure}}
                    </div>
                  </v-col>
                </v-row>

                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">

                      {{$t('measure.measureResponsible')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2">
                      {{measure.measureResponsible.name}}
                    </div>
                  </v-col>
                </v-row>


                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">

                      {{$t('measure.status')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2">
                      {{measure.status}}
                    </div>
                  </v-col>
                </v-row>

                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">

                      {{$t('measure.dateClosed')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="h2">
                      {{measure.dateClosed}}
                    </div>
                  </v-col>
                </v-row>



                <v-row align="end">
                  <v-col cols="2">
                    <div class="h2 font-weight-bold">
                      {{$t('measure.commentOnClosed')}}:
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div style="white-space: pre-line;">
                      {{measure.commentOnClosed}}
                    </div>
                  </v-col>
                </v-row>


              </v-container>

            </v-card-text>
          </v-card>

        </v-col>
      </v-row>


    </v-expansion-panel-content>

  </v-expansion-panel>
  <!--
      <v-row>
        <v-col>

          <h2 class="font-weight-light mb-4">
            {{$t('potentialIncident.barriers')}}
          </h2>
          <v-row v-for="barrier in barriers">
            <v-col>


              <v-card elevation="2">
                <v-card-text>
                  <v-container class="pa-0" fluid>

                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">
                          {{$t('barrier.description')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2">
                          {{barrier.description}}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">

                          {{$t('barrier.type')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2" v-if="barrier.type!=''">
                          {{$t('barrierType.' +barrier.type)}}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">
                          {{$t('barrier.strong')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2" v-if="barrier.strength">
                          {{$t('global.yes')}}
                        </div>
                        <div class="h2" v-else>
                          {{$t('global.no')}}
                        </div>
                      </v-col>
                    </v-row>


                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">
                          {{$t('barrier.owner')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2">
                          {{barrier.owner.name}}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">
                          {{$t('barrier.comment')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div style="white-space: pre-line;">
                          {{barrier.comment}}
                        </div>
                      </v-col>
                    </v-row>


                  </v-container>

                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>

          <h2 class="font-weight-light mb-4">
            {{$t('potentialIncident.measures')}}
          </h2>
          <v-row v-for="measure in measures">
            <v-col>


              <v-card elevation="2">
                <v-card-text>
                  <v-container class="pa-0" fluid>

                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">
                          {{$t('measure.measure')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2">
                          {{measure.measure}}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">

                          {{$t('measure.measureResponsible')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2">
                          {{measure.measureResponsible}}
                        </div>
                      </v-col>
                    </v-row>


                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">

                          {{$t('measure.status')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2">
                          {{measure.status}}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">

                          {{$t('measure.dateClosed')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div class="h2">
                          {{measure.dateClosed}}
                        </div>
                      </v-col>
                    </v-row>



                    <v-row align="end">
                      <v-col cols="2">
                        <div class="h2 font-weight-bold">
                          {{$t('measure.commentOnClosed')}}:
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <div style="white-space: pre-line;">
                          {{measure.commentOnClosed}}
                        </div>
                      </v-col>
                    </v-row>


                  </v-container>

                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </v-col>
      </v-row>
  -->
</v-expansion-panels>
    <v-row>

    </v-row>


  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import riskUtil from '../utils/riskutil'

    export default {
        data() {

            return {
                logicalId:"",
                id: "",
                projectId: "",
                workOperationName: "",
                workTypeName: "",
                consequenceTypeName: "",
                consequence:"",
                consequenceText: "",
                consequenceAfterMeasures: "",
              consequenceAfterMeasuresText:"",
                consequenceTypeAfterMeasuresName: "",
                incidentTypeName: "",
                location: "",
                measures: [],
                probability: "",
                probabilityAfterMeasures: "",
              probabilityAfterMeasuresText:"",
                explanation: "",
                risk: "",
                riskAfterMeasures: "",
                barriers: []


            }
        },
        methods: {
            getPotentialIncident(incidentId) {
                api.getPotentialIncident(incidentId).then(response => {
                    this.id = response.id
                    this.logicalId = response.logicalId
                    this.projectId = response.projectId
                    this.workOperationName = response.workOperation.name
                    this.workTypeName = response.workType.name
                    this.consequenceTypeName = response.consequenceType.name
                    this.incidentTypeName = response.incidentType.name
                    this.location = response.location.name
                    this.measures = response.measures
                    this.probability = response.probability
                    this.probabilityAfterMeasuresText = response.probabilityAfterMeasures != null ? response.probabilityAfterMeasures.name + " (" + response.probabilityAfterMeasures.id + ")" : ""
                  this.probabilityAfterMeasures = response.probabilityAfterMeasures
                    this.risk = response.risk
                    this.riskAfterMeasures = response.riskAfterMeasures
                    this.consequenceText = response.consequence != null ? response.consequence.name + " (" + response.consequence.id + ")" : ""
                    this.consequence = response.consequence
                  this.consequenceAfterMeasures = response.consequenceAfterMeasures
                    this.consequenceAfterMeasuresText = response.consequenceAfterMeasures != null ? response.consequenceAfterMeasures.name + " (" + response.consequenceAfterMeasures.id + ")" : ""
                    this.explanation = response.explanation
                    this.barriers = response.barriers

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },

            backToProject() {
                this.$router.push({path: '/projectShow/' + this.projectId});
            },
            clonePotentialIncident() {
                this.$router.push({
                    name: 'PotentialIncidentCreateFromTemplate',
                    params: {"templatePotentialIncidentId": this.id}
                })
            },
          getLevel(obj) {
            if (obj==null || typeof obj != 'object') {
              return obj;
            } else {
              return obj.id;
            }
          }
        },
        mounted() {
            this.getPotentialIncident(this.$route.params.id)
        },
        computed: {
          riskColor() {
             return riskUtil.getRiskColor(this.probability.id, this.consequence.id)
          },
          riskAfterMeasuresColor() {
            return riskUtil.getRiskColor( this.getLevel(this.probabilityAfterMeasures), this.getLevel(this.consequenceAfterMeasures))
       }
        }
    }
</script>
